// Lets a page open the top bar's installer download menu (the same menu as the
// download icon) without owning the top bar's state.
const OPEN_INSTALLER_DOWNLOAD_EVENT = 'top-navigation:open-installer-download'

export const openInstallerDownloadMenu = (): void => {
  window.dispatchEvent(new Event(OPEN_INSTALLER_DOWNLOAD_EVENT))
}

export const subscribeToOpenInstallerDownload = (
  listener: () => void,
): (() => void) => {
  window.addEventListener(OPEN_INSTALLER_DOWNLOAD_EVENT, listener)
  return () =>
    window.removeEventListener(OPEN_INSTALLER_DOWNLOAD_EVENT, listener)
}
